export default __webpack_public_path__ + "static/Industrial_Grill-49c1325e182d89a623a458a7a997e0a1.png";